<template>
  <div v-if="$store.state.user" class="mesAlertes compteTab">
    <div>
      <h2>Mes alertes par email</h2>
      <div class="simpleForm invert">
        <div>
          <input
            v-for="(alt, n) in mail"
            :id="alt.field"
            :key="n"
            @change="change($event, alt)"
            v-model="$store.state.user[alt.field]"
            true-value="true"
            false-value="false"
            type="checkbox"
          />
        </div>
        <div>
          <label v-for="(alt, n) in mail" v-html="alt.message" :key="n" :for="alt.field" />
        </div>
      </div>
    </div>
    <div>
      <h2>Mes alertes web (lorsque je suis en ligne)</h2>
      <div class="simpleForm invert">
        <div>
          <input
            v-for="(alt, n) in web"
            :id="alt.field"
            :key="n"
            @change="change($event, alt)"
            v-model="$store.state.user[alt.field]"
            true-value="true"
            false-value="false"
            type="checkbox"
          />
        </div>
        <div>
          <label v-for="(alt, n) in web" v-html="alt.message" :key="n" :for="alt.field" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { idyuJsonRpc } from "@/assets/js/idyu/connect.js";

export default {
  name: "MesAlertes",

  data() {
    return {
      mail: [
        {
          field: "mailMail",
          message: "Je souhaite être alerté" + this.ee() + " lors de la réception d'un nouveau message."
        },
        {
          field: "mailFlash",
          message: "Je souhaite être alerté" + this.ee() + " lors de la réception d'un nouveau flash."
        },
        {
          field: "mailVisit",
          message: "Je souhaite être alerté" + this.ee() + " lorsqu'un membre visite mon profil."
        },
        {
          field: "mailFriend",
          message: "Je souhaite être alerté" + this.ee() + " lorsqu'un membre m'ajoute à ses favoris."
        },
        {
          field: "mailNewMembers",
          message: "Je souhaite recevoir des annonces de profils pouvant m'intéresser."
        },
        {
          field: "mailAdds",
          message:
            "Je souhaite bénéficier des offres de réduction tarifaires d'" + this.$store.state.siteConst.coloredName
        },
        {
          field: "mailPartnerAdds",
          message:
            `Je souhaite être informé${this.ee()} des offres promotionnelles des partenaires d'` +
            this.$store.state.siteConst.coloredName
        }
      ],

      web: [
        {
          field: "alertChat",
          message: "Je souhaite être alerté" + this.ee() + " lors de la réception d'un nouveau message."
        },
        {
          field: "alertFlash",
          message: "Je souhaite être alerté" + this.ee() + " lors de la réception d'un nouveau flash."
        },
        {
          field: "alertVisit",
          message: "Je souhaite être alerté" + this.ee() + " lorsqu'un membre visite mon profil."
        },
        {
          field: "messageBell",
          message: `Je souhaite être alerté${this.ee()} par un signal sonore lorsque je reçois un message.`
        }
      ]
    };
  },
  methods: {
    ee: function() {
      if (!this.$store.state.profile) return "";
      if (this.$store.state.profile.sex === "FEMALE") return "e";
      return "";
    },

    change: function(event, alt) {
      const obj = {};
      obj[alt.field] = event.target.checked;

      idyuJsonRpc("updateUserAlerts", obj);
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/css/vars.scss";
@import "@/assets/css/forms.scss";
@import "@/assets/css/compte.scss";
</style>
